import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faArrowAltCircleLeft,
  faAngleDown,
  faAngleRight,
  faCheck,
  faChevronLeft,
  faChevronRight,
  faExpandWide,
  faRedoAlt,
  faInfoCircle
} from '@fortawesome/pro-regular-svg-icons';


library.add(
  faArrowAltCircleLeft,
  faAngleDown,
  faAngleRight,
  faCheck,
  faChevronLeft,
  faChevronRight,
  faExpandWide,
  faRedoAlt,
  faInfoCircle,
);
